import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { DealerAssistTableErrorCode } from '../models/communication/app-enums.model';
import { ErrorCodePipe } from '../pipes/error-code/error-code.pipe';

@Component({
    selector: 'app-error-panel',
    standalone: true,
    imports: [CommonModule, ErrorCodePipe],
    templateUrl: './error-panel.component.html',
    styleUrl: './error-panel.component.scss'
})
export class ErrorPanelComponent {
    @Input()
    errorCode?: DealerAssistTableErrorCode;
}
